
const BrochureHero = () => {
  return (
    <section 
      className="relative py-24 bg-cover bg-center"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url('https://public.readdy.ai/ai/img_res/748fce9c3f2b4e0d578f2fbea7fe1b81.jpg')`
      }}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 text-center">
        <h1 className="text-5xl font-bold text-white mb-6">
          Chemical Supply Projects Portfolio
        </h1>
        <p className="text-xl text-gray-200 mb-8 max-w-4xl mx-auto">
          Comprehensive overview of Golden Black's chemical supply projects across upstream, 
          midstream, and downstream operations. Specialized services for ADNOC Onshore and Offshore operations.
        </p>
        <div className="grid md:grid-cols-4 gap-6 max-w-4xl mx-auto">
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4">
            <h3 className="text-white font-bold text-lg">Upstream</h3>
            <p className="text-gray-200 text-sm">Drilling & Production</p>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4">
            <h3 className="text-white font-bold text-lg">Production</h3>
            <p className="text-gray-200 text-sm">Enhancement & Protection</p>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4">
            <h3 className="text-white font-bold text-lg">Midstream</h3>
            <p className="text-gray-200 text-sm">Transportation & Storage</p>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4">
            <h3 className="text-white font-bold text-lg">Downstream</h3>
            <p className="text-gray-200 text-sm">Refining & Processing</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BrochureHero;
